export function truncateTextWithEllipsis(element, maxLines) {
  const originalText = element.textContent;
  const lineHeight = parseInt(getComputedStyle(element).lineHeight) ||
    parseInt(getComputedStyle(element).fontSize) * 1.2;
  const maxHeight = lineHeight * maxLines;

  element.textContent = originalText;
  element.style.webkitLineClamp = 'none';
  element.style.lineClamp = 'none';

  if (element.scrollHeight <= maxHeight) {
    return;
  }

  function truncate() {
    let text = originalText;
    let words = text.split(' ');
    let low = 0;
    let high = words.length;
    let result = '';

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const testText = words.slice(0, mid).join(' ') + '...';
      element.textContent = testText;

      if (element.scrollHeight <= maxHeight) {
        result = testText;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    element.textContent = result || '...';
  }

  truncate();
}

export function getMaxItemsByWordLimit(
  items: any[],
  dataKey: string,
  maxWords: number = 160): number {
  let totalWords = 0;
  let maxItems = 0;

  for (const item of items) {
    const text = item[dataKey];
    if (text === undefined) continue;

    const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
    if (totalWords + wordCount > maxWords) break;
    totalWords += wordCount;
    maxItems++;
  }

  return maxItems;
}